// extracted by mini-css-extract-plugin
module.exports = {"more_tabs":"more_tabs-3Yzyd9Ad","title":"title-N9xF3l4r","more":"more-1_YBGtzG"};